
import { FSharpRef, Union } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { string_type, union_type, class_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { tryParse, newGuid } from "../fable_modules/fable-library-js.5.3.0/Guid.js";
import { substring, isNullOrWhiteSpace } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.3.0/Result.js";
import { filter, length, exists } from "../fable_modules/fable-library-js.5.3.0/Seq.js";
import { isControl, isWhiteSpace } from "../fable_modules/fable-library-js.5.3.0/Char.js";

export class UserId extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["UserId"];
    }
}

export function UserId_$reflection() {
    return union_type("Shared.UserId", [], UserId, () => [[["Item", class_type("System.Guid")]]]);
}

export function UserIdModule_create() {
    return new UserId(newGuid());
}

export function UserIdModule_createFrom(guid) {
    return new UserId(guid);
}

export function UserIdModule_value(_arg) {
    return _arg.fields[0];
}

export function UserIdModule_toString(_arg) {
    return _arg.fields[0];
}

export function UserIdModule_parse(str) {
    let matchValue;
    let outArg = "00000000-0000-0000-0000-000000000000";
    matchValue = [tryParse(str, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return new UserId(matchValue[1]);
    }
    else {
        return undefined;
    }
}

export class ZitadelUserId extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ZitadelUserId"];
    }
}

export function ZitadelUserId_$reflection() {
    return union_type("Shared.ZitadelUserId", [], ZitadelUserId, () => [[["Item", string_type]]]);
}

export function ZitadelUserIdModule_create(value) {
    if (isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["Zitadel user ID cannot be empty"]);
    }
    else {
        return new FSharpResult$2(0, [new ZitadelUserId(value)]);
    }
}

export function ZitadelUserIdModule_value(_arg) {
    return _arg.fields[0];
}

export class EmailAddress extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["EmailAddress"];
    }
}

export function EmailAddress_$reflection() {
    return union_type("Shared.EmailAddress", [], EmailAddress, () => [[["Item", string_type]]]);
}

export function EmailAddressModule_create(value) {
    if (isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["Email address cannot be empty"]);
    }
    else {
        const trimmed = value.trim();
        if (exists((c) => {
            if (isWhiteSpace(c)) {
                return true;
            }
            else {
                return isControl(c);
            }
        }, trimmed.split(""))) {
            return new FSharpResult$2(1, ["Invalid email address format"]);
        }
        else if (length(filter((y) => ("@" === y), trimmed.split(""))) !== 1) {
            return new FSharpResult$2(1, ["Invalid email address format"]);
        }
        else {
            const atIndex = trimmed.indexOf("@") | 0;
            if ((substring(trimmed, 0, atIndex) === "") ? true : (substring(trimmed, atIndex + 1) === "")) {
                return new FSharpResult$2(1, ["Invalid email address format"]);
            }
            else {
                return new FSharpResult$2(0, [new EmailAddress(trimmed)]);
            }
        }
    }
}

export function EmailAddressModule_fromIdentityProvider(value) {
    if (isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["Email address cannot be empty"]);
    }
    else {
        return new FSharpResult$2(0, [new EmailAddress(value.trim())]);
    }
}

export function EmailAddressModule_isNovuDeliverable(value) {
    const matchValue = value.lastIndexOf("@") | 0;
    if (matchValue === -1) {
        return false;
    }
    else {
        return substring(value, matchValue + 1).indexOf(".") >= 0;
    }
}

export function EmailAddressModule_value(_arg) {
    return _arg.fields[0];
}

export class UserName extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["UserName"];
    }
}

export function UserName_$reflection() {
    return union_type("Shared.UserName", [], UserName, () => [[["Item", string_type]]]);
}

export function UserNameModule_create(value) {
    if (isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["User name cannot be empty"]);
    }
    else if (value.length < 2) {
        return new FSharpResult$2(1, ["User name must be at least 2 characters"]);
    }
    else if (value.length > 50) {
        return new FSharpResult$2(1, ["User name must not exceed 50 characters"]);
    }
    else {
        return new FSharpResult$2(0, [new UserName(value)]);
    }
}

export function UserNameModule_value(_arg) {
    return _arg.fields[0];
}

export class ProfileBio extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ProfileBio"];
    }
}

export function ProfileBio_$reflection() {
    return union_type("Shared.ProfileBio", [], ProfileBio, () => [[["Item", string_type]]]);
}

export function ProfileBioModule_create(value) {
    if (value.length > 500) {
        return new FSharpResult$2(1, ["Bio must not exceed 500 characters"]);
    }
    else {
        return new FSharpResult$2(0, [new ProfileBio(value)]);
    }
}

/**
 * Validates bio as required (non-empty, non-whitespace) with max length.
 * Used by profile completion flow where bio is mandatory.
 */
export function ProfileBioModule_createRequired(value) {
    if (isNullOrWhiteSpace(value)) {
        return new FSharpResult$2(1, ["Bio is required"]);
    }
    else {
        return ProfileBioModule_create(value);
    }
}

export function ProfileBioModule_value(_arg) {
    return _arg.fields[0];
}

//# sourceMappingURL=User.js.map
